import { Component, inject } from '@angular/core';
import { PageShellComponent } from '../page-shell.component';
import { Router } from '@angular/router';
import { SwitchDivisionService } from '@r1-compass-library/services/switch-division.service';
import { SelectDivisionComponent } from '../select-division/select-division.component';
import { UsersIamDivisionChoice } from '@r1-compass-library/models';
import { GlobalLoggedInUserStore } from '@r1-compass-library/store/logged-in-user/global-logged-in-user.store';

@Component({
    selector: 'r1-compass-app-switch-division',
    imports: [PageShellComponent, SelectDivisionComponent],
    template: `
        <r1-compass-app-page-shell>
            <r1-compass-app-select-division [divisions]="divisions()" (selectDivision)="onSwitchDivision($event)" />
        </r1-compass-app-page-shell>
    `,
})
export class SwitchDivisonComponent {
    readonly #router = inject(Router);
    readonly #switchDivisionService = inject(SwitchDivisionService);
    readonly #loggedInUserStore = inject(GlobalLoggedInUserStore);

    readonly divisions = this.#loggedInUserStore.usersAvailableDivisions;

    onSwitchDivision(division: UsersIamDivisionChoice) {
        this.#switchDivisionService.switchDivision(division.id, division.divisionCode).subscribe(() => {
            this.#router.navigate(['/plays'], {
                queryParams: { folderId: 0 },
            });
        });
    }
}
